// @core/api/endpoints/webhook/list_endpoints.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEndpointsResponse,
} from '../../../types/webhook';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/webhook';

/**
 * List webhook endpoints
 * Returns all configured webhook endpoints with optional filtering by status and subscribed event types.
 */
export async function ListEndpoints(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEndpointsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/endpoints`;
  const requestOptions = options;
  return client.get<ListEndpointsResponse>(requestPath, { ...requestOptions, params });
}
